module.exports = __webpack_public_path__ + "media/img/business-background-biznes-59eda669.svg";